import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate, useSearchParams } from "react-router-dom";

const PaymentFailed = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderNo = params.get("order_no");

  return (
    <Container className="text-center py-5">
      <h2 className="text-danger">✕ Payment Cancelled / Failed</h2>
      <p>Your payment was cancelled or failed.</p>
      {orderNo && <p><b>Order No:</b> {orderNo}</p>}

      <Button onClick={() => navigate("/checkout")}>
        Try Again
      </Button>
    </Container>
  );
};

export default PaymentFailed;

